export default "__VITE_ASSET__C5mwvCl___"